let currentPage = 'home';

export function setCurrentPage(page){
    return currentPage = page;
}
export function getCurrentPage(){
    return currentPage;
}